/** Routes marketing publiques — boot léger (pas de session, pas d'icônes Material, pas de Crisp). */
export const MARKETING_PUBLIC_PATHS = ['/', '/blog', '/presse', '/press'];

export function normalizeMarketingPath(path = '') {
  const normalized = String(path || '')
    .split('?')[0]
    .replace(/\/+$/, '');
  return normalized || '/';
}

export function isBlogPath(path = '') {
  const normalized = normalizeMarketingPath(path);
  return normalized === '/blog' || normalized.startsWith('/blog/');
}

export function isPressPath(path = '') {
  const normalized = normalizeMarketingPath(path);
  return normalized === '/presse' || normalized === '/press';
}

export function isMarketingPublicPath(path = '') {
  const normalized = normalizeMarketingPath(path);
  return (
    MARKETING_PUBLIC_PATHS.includes(normalized) ||
    isBlogPath(normalized) ||
    isPressPath(normalized)
  );
}

/** Pages publiques sans restauration de session au boot (auth + marketing). */
export const LIGHT_BOOT_PUBLIC_PATHS = [
  '/signin',
  '/signup',
  '/protected',
  '/expired',
  '/auth',
  ...MARKETING_PUBLIC_PATHS,
];

export function isLightBootPublicPath(path = '') {
  const normalized = normalizeMarketingPath(path);
  if (LIGHT_BOOT_PUBLIC_PATHS.includes(normalized)) return true;
  return isBlogPath(normalized) || isPressPath(normalized);
}

/** Pages accessibles sans authentification (router guard). */
export const PUBLIC_ACCESS_PATHS = [
  '/signin',
  '/signup',
  '/protected',
  '/expired',
  '/auth',
  ...MARKETING_PUBLIC_PATHS,
];

export function isPublicAccessPath(path = '') {
  const normalized = normalizeMarketingPath(path);
  if (PUBLIC_ACCESS_PATHS.includes(normalized)) return true;
  return isBlogPath(normalized) || isPressPath(normalized);
}

/** Pages sans barres verticales (layout app). */
export const NO_VERTICAL_BARS_PATHS = [
  '/',
  '/signup',
  '/signin',
  '/protected',
  '/expired',
  '/auth',
  '/blog',
  '/presse',
  '/press',
];

export function hidesVerticalBars(path = '') {
  const normalized = normalizeMarketingPath(path);
  if (NO_VERTICAL_BARS_PATHS.includes(normalized)) return true;
  return isBlogPath(normalized) || isPressPath(normalized);
}
